import pluralize from 'pluralize'

export type SeatNoun = 'seat' | 'assistant seat'

export const seatFloorHint = (entered: number | null, current: number | undefined, occupied: number | undefined, noun: SeatNoun): string | null => {
  if (entered === null || current === undefined || occupied === undefined) {
    return null
  }
  if (entered >= current || entered >= occupied) {
    return null
  }
  return `Enter ${occupied} or more. This account has ${occupied} ${pluralize(noun, occupied)} assigned.`
}
